'use client'

import { ReactNode } from 'react'
import { useRouter } from 'next/navigation'

type NavigateToSectionProps = {
  children: ReactNode
  sectionId: string
  className?: string
}

export default function NavigateToSection({ children, sectionId, className }: NavigateToSectionProps): JSX.Element {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault()

    // Store the target section in sessionStorage to scroll immediately on page load
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('scrollToSection', sectionId)
    }

    // Navigate to v1 page with hash
    router.push(`/v1#${sectionId}`)
  }

  return (
    <a href={`/v1#${sectionId}`} className={className} onClick={handleClick}>
      {children}
    </a>
  )
}
